import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import menu2Fill from '@iconify/icons-eva/menu-2-fill'
import searchFill from '@iconify/icons-eva/search-fill'
import { QrCodeScanner, Close, Search, SwitchAccount, Lock, Person, ExitToApp, CampaignOutlined, ZoomOutMap, Remove, Add } from '@material-ui/icons'
import sunFill from '@iconify/icons-eva/sun-fill'
import moonFill from '@iconify/icons-eva/moon-fill'
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Typography,
  Tooltip,
  Switch,
  FormControlLabel,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  useTheme,
  Card,
  Grid,
  Container,
  Popover,
  Divider,
} from '@material-ui/core'
// components
import { MHidden } from '../../components/@material-extend'
import { Html5QrcodeScanner } from 'html5-qrcode'
import { LoadingButton } from '@material-ui/lab'
//
import AccountPopover from './AccountPopover'

import LanguagePopover from './LanguagePopover'
import ContactsPopover from './ContactsPopover'
import NotificationsPopover from './NotificationsPopover'
import SettingFullscreen from 'src/components/settings/SettingFullscreen'
import AIChatbot from './AIChatbot'
import ChatbotTestBackup from 'src/components/_dashboard/chatbot/ChatbotTestBackup.js'
import Lottie from 'lottie-react'
import ZoomLottieAnimation from 'src/Gif/zoom.json'
// import Typography from 'src/theme/overrides/Typography'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Theme } from '@fullcalendar/react'
import useAuth from 'src/hooks/useAuth'
import { PATH_DASHBOARD } from 'src/routes/paths'
import FloatingChat from 'src/pages/dashboard/ChatModuleSignwise/FloatingChatButton'
import NoteStickyIndividual from './individualStickynote'
import NoteStickyIndividualPopup from './individualStickynotePopup'
import axios from 'axios'
import { useEffect, useState, useRef, useMemo, useCallback, memo } from 'react'
import { currentFacilityName, QBShow, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import {
  APP_ZOOM_MODE_COMPACT,
  APP_ZOOM_MODE_VISUAL,
  clearLegacyZoomStorage,
  clampZoomPercent,
  DEFAULT_APP_ZOOM_PERCENT,
  // getStoredZoomForUser, // used by commented software-zoom init below
  MAX_APP_ZOOM_PERCENT,
  MIN_APP_ZOOM_PERCENT,
  normalizeZoomMode,
  setStoredZoomForUser
} from 'src/utils/appZoomPreference'
import { useSnackbar } from 'notistack'
import useCompanyProfile from 'src/hooks/useCompanyProfile'
import useSettings from 'src/hooks/useSettings'
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
}

const QB_GREEN = '#2CA01C'
const QB_MARQUEE_TEXT = "We're Moving to QB Production!"
const QB_MARQUEE_REPEAT_COUNT = 10
const APP_ZOOM_STEP = 5

const isChromiumBrowser = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  const brands = navigator.userAgentData?.brands || []
  if (Array.isArray(brands) && brands.length > 0) {
    return brands.some((brandEntry) => /Chrom|Chrome|Edge|Opera/i.test(brandEntry?.brand || ''))
  }
  const userAgent = navigator.userAgent || ''
  const hasChromiumToken = /(Chrome|Chromium|Edg|OPR)/i.test(userAgent)
  const hasFirefoxOrSafariToken = /(Firefox|Safari)/i.test(userAgent) && !/(Chrome|Chromium|Edg|OPR)/i.test(userAgent)
  return hasChromiumToken && !hasFirefoxOrSafariToken
}

const hexToLottieColor = (hex) => {
  const normalized = hex.replace('#', '')
  return [
    parseInt(normalized.substring(0, 2), 16) / 255,
    parseInt(normalized.substring(2, 4), 16) / 255,
    parseInt(normalized.substring(4, 6), 16) / 255,
    1,
  ]
}

const applyLottiePrimaryColor = (animation, color, strokeScale = 1) => {
  const clone = JSON.parse(JSON.stringify(animation))

  const applyStyleToItems = (items) => {
    items?.forEach((item) => {
      if ((item.ty === 'st' || item.ty === 'fl') && item.c?.k) {
        item.c.k = color
      }
      if (item.ty === 'st' && typeof item.w?.k === 'number' && strokeScale !== 1) {
        item.w.k = Math.round(item.w.k * strokeScale)
      }
      if (item.it) applyStyleToItems(item.it)
    })
  }

  clone.layers?.forEach((layer) => {
    layer.shapes?.forEach((shape) => {
      applyStyleToItems(shape.it)
    })
  })

  return clone
}

const QBSyncBanner = styled('div')(({ theme }) => ({
  width: '100%',
  borderRadius: 14,
  overflow: 'hidden',
  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${QB_GREEN} 60%, ${theme.palette.primary.main} 100%)`,
  boxShadow: theme.shadows?.[6] || '0 10px 32px rgba(0,0,0,0.18)',
  border: `1px solid ${alpha(theme.palette.common.white, 0.14)}`,
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background:
      'radial-gradient(60% 120% at 10% 0%, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 60%)',
    pointerEvents: 'none',
  },
}))

const QBSyncTrack = styled('div')({
  display: 'flex',
  width: '200%',
  willChange: 'transform',
  animation: 'qbSyncMarquee 16s linear infinite',
  '@keyframes qbSyncMarquee': {
    '0%': { transform: 'translateX(0)' },
    '100%': { transform: 'translateX(-50%)' },
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    transform: 'none',
  },
})

const QBSyncRow = styled('div')(({ theme }) => ({
  flex: '0 0 100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  gap: theme.spacing(4),
  padding: theme.spacing(0.75, 2),
  whiteSpace: 'nowrap',
}))

const QBSyncText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 800,
  letterSpacing: 0.3,
  textShadow: '0 10px 22px rgba(0,0,0,0.22)',
}))

const MaintenanceBanner = styled('div')(({ theme }) => ({
  width: '100%',
  borderRadius: 14,
  overflow: 'hidden',
  background: `linear-gradient(90deg, #d32f2f 0%, #ed6c02 60%, #d32f2f 100%)`,
  boxShadow: theme.shadows?.[6] || '0 10px 32px rgba(0,0,0,0.18)',
  border: `1px solid ${alpha(theme.palette.common.white, 0.14)}`,
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background:
      'radial-gradient(60% 120% at 10% 0%, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 60%)',
    pointerEvents: 'none',
  },
}))

const MaintenanceText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 800,
  letterSpacing: 0.3,
  textShadow: '0 10px 22px rgba(0,0,0,0.22)',
}))

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}))

const APPBAR_MOBILE = 64
const APPBAR_DESKTOP = 92

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
  backgroundColor: alpha(theme.palette.background.default, 0.72),
}))

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}))

const BarcodeSearchField = memo(function BarcodeSearchField({ onSearch, onOpenQRScanner }) {
  const [value, setValue] = useState('')
  const [searching, setSearching] = useState(false)

  const runSearch = async () => {
    const barcode = (value || '').trim()
    if (!barcode || searching) return
    setSearching(true)
    try {
      await onSearch(barcode)
      setValue('')
    } finally {
      setSearching(false)
    }
  }

  return (
    <TextField
      size="small"
      placeholder="Search barcode…"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          runSearch()
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon icon={searchFill} width={20} height={20} />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {searching ? (
              <CircularProgress size={20} sx={{ mr: 1 }} />
            ) : (
              <>
                <Tooltip title="Search">
                  <IconButton size="small" onClick={runSearch}>
                    <Search sx={{ fontSize: '20px' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Scan QR Code">
                  <IconButton size="small" onClick={onOpenQRScanner}>
                    <QrCodeScanner sx={{ fontSize: '20px' }} />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </InputAdornment>
        ),
      }}
      sx={{
        minWidth: '250px',
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'background.paper',
        },
      }}
    />
  )
})

export default function DashboardNavbar({ onOpenSidebar, isCompact }) {
  const theme = useTheme()
  const { themeMode, onChangeMode } = useSettings()
  const { loginWithUserId, loginWithPin, method } = useAuth()
  const { enqueueSnackbar } = useSnackbar()
  const { COMPANY_NAME } = useCompanyProfile()
  let user = null
  try {
    const raw = window.localStorage.getItem('user')
    if (raw && raw !== 'null' && raw !== 'undefined') {
      user = JSON.parse(raw)
    }
  } catch (e) {
    user = null
  }
  let user_id = localStorage.getItem('user_id')
  let user_type = localStorage.getItem('user_type')
  let admin = false
  let parentId = user?.parent_id
  let addedByClient = user?.added_by_client
  let isFromAdmin = user?.isFromAdmin
  const [isActive, setIsActive] = useState(false);
  const [openQRScanner, setOpenQRScanner] = useState(false);
  const [isQBBannerDismissed, setIsQBBannerDismissed] = useState(false);
  const [zoomAnchorPosition, setZoomAnchorPosition] = useState(null);
  const [zoomPercent, setZoomPercent] = useState(DEFAULT_APP_ZOOM_PERCENT);
  const [zoomMode, setZoomMode] = useState(APP_ZOOM_MODE_VISUAL);
  const [maintenanceBannerShow, setMaintenanceBannerShow] = useState(
    localStorage.getItem('maintenance_banner_show') === 'true'
  );
  const [maintenanceBannerText, setMaintenanceBannerText] = useState(
    localStorage.getItem('maintenance_banner_text') || ''
  );
  const [isMaintenanceDismissed, setIsMaintenanceDismissed] = useState(false);
  const scannerRef = useRef(null);
  const zoomButtonRef = useRef(null);
  console.log('isFromAdmin', isFromAdmin)
  
  let explodedPermissions = user?.exploded_permissions
  const hasSwitchUserPinPermission = explodedPermissions?.some((permission) => ['Switch User With Pin'].includes(permission)) ? true : false
  // ----------------------------------------------------------------------

  const DRAWER_WIDTH = isCompact ? 80 : 280

  // ----------------------------------------------------------------------

  const navigate = useNavigate()
  const location = useLocation()
  if (user_id != user?.user_id) {
    admin = true
  }

  // Check if user has switched (using PIN or from admin/client)
  const originalUserId = localStorage.getItem('original_user_id')
  const pinUserId = localStorage.getItem('pin_user_id')
  const isSwitchedViaPin = localStorage.getItem('switched_via_pin') === 'true'
  const isSwitchedNormally = !!(user?.isFromAdmin || user?.isFromClient)
  const isClientUser = !!user?.isClient
  const isVendorUser = !!user?.isVendor
  const hasSwitched = !!(originalUserId || isSwitchedViaPin || isSwitchedNormally)
  const isInPinSwitchSession = isSwitchedViaPin && !!originalUserId
  const displayUserName = user != null ? (user.first_name || user.name || '') : ''
  const shouldShowSwitchWithPinInToolbar =
    !isClientUser &&
    !isVendorUser &&
    hasSwitchUserPinPermission &&
    !originalUserId &&
    !isSwitchedViaPin &&
    !isSwitchedNormally
  const shouldShowSwitchWithPinWhenSwitched =
    !isClientUser &&
    !isVendorUser &&
    isInPinSwitchSession

  const exitPinSwitch = async () => {
    if (!originalUserId) {
      return
    }

    try {
      // When switching back, we're returning to the original user, so no need for isFromClient/isFromAdmin flags
      const parsedOriginalId = parseInt(originalUserId, 10)
      if (Number.isNaN(parsedOriginalId)) return

      // Proactively restore user id in localStorage in case auth logic relies on it
      localStorage.setItem('user_id', String(parsedOriginalId))
      const originalUserType = localStorage.getItem('original_user_type')
      if (originalUserType) {
        localStorage.setItem('user_type', originalUserType)
      }

      await Promise.resolve(loginWithUserId(1, parsedOriginalId, false, false))

      // Clear the stored original user info and PIN switch flag
      localStorage.removeItem('original_user_id')
      localStorage.removeItem('original_user_type')
      localStorage.removeItem('switched_via_pin')
      localStorage.removeItem('pin_user_id')

      navigate(PATH_DASHBOARD.switchUserWithPin, { replace: true })
      window.location.reload()
    } catch (e) {
      console.error('Failed to exit PIN switch', e)
    }
  }

  const switchBackToOriginalUser = async () => {
    // In a nested switch scenario (admin -> PIN user -> normal switch),
    // "Switch Back" should go to the PIN user (e.g. Eli White), not the original admin.
    let targetId = null

    if (isSwitchedViaPin && pinUserId) {
      targetId = parseInt(pinUserId, 10)
      targetId = parseInt(pinUserId, 10)
    } else if (originalUserId) {
      targetId = parseInt(originalUserId, 10)
    }

    if (!targetId || Number.isNaN(targetId)) {
      return
    }

    try {
      localStorage.setItem('user_id', String(targetId))
      await Promise.resolve(loginWithUserId(1, targetId, false, false))

      navigate(PATH_DASHBOARD.root, { replace: true })
      window.location.reload()
    } catch (e) {
      console.error('Failed to switch back to original user', e)
    }
  }

  const loginAsUser = () => {
    let isFromAdmin = false
    let isFromClient = false
    loginWithUserId(1, user_id, isFromClient, isFromAdmin)

    setTimeout(() => {
      if (user?.isVendor) {
        navigate(PATH_DASHBOARD.client.vendors, { state: true })
      } else if (user?.team_id) {
        navigate(PATH_DASHBOARD.callCenter.teamaccount, {
          state: { data: user?.team_id, isTeam: true },
        })
      } else if (user?.driver_id) {
        const id = user?.driver_id
        navigate(`${PATH_DASHBOARD.transportation.viewdriver}/${id}`)
      } else {
        navigate(PATH_DASHBOARD.client.cards, { state: true })
      }
      window.location.reload()
    }, 1000)
  }

  const loginAsClient = () => {
    let isFromClient = false
    let swithUser = addedByClient ? parentId : user_id
    loginWithUserId(1, swithUser, isFromClient, isFromAdmin)

    setTimeout(() => {
      if (user?.isVendor) {
        navigate(PATH_DASHBOARD.client.vendors, { state: true })
      } else if (user?.team_id) {
        navigate(PATH_DASHBOARD.callCenter.teamaccount, {
          state: { data: user?.team_id, isTeam: true },
        })
      } else if (user?.driver_id) {
        const id = user?.driver_id
        navigate(`${PATH_DASHBOARD.transportation.viewdriver}/${id}`)
      } else {
        navigate(PATH_DASHBOARD.client.cards, { state: true })
      }
      window.location.reload()
    }, 1000)
  }

  const handleActiveToggle = async (checked) => {
  try {
    const response = await axios.post(`${REST_API_END_POINT}teams/update-user-active`, {
      user_id: user.user_id,
      online: checked ? 1 : 0
    });

    if (response?.data?.status === 1) {
      
      console.log('resresponse?.data?.status',response.data.message )
      setIsActive(checked);
      enqueueSnackbar(response.data.message, { variant: 'success' });
    }
    else{
      enqueueSnackbar(response.data.message, { variant: 'error' });
    }
  } catch (err) {
    console.error(err);
  }
};

const handleThemeToggle = async (theme) => {
  try {
    localStorage.setItem('themeMode', theme);
    await axios.post(`${REST_API_END_POINT}teams/update-theme-for-user`, {
      userId: user.user_id,
      theme
    });
  }
  catch (err) {
    console.error(err);
  }
}
  const applyZoomPreference = useCallback((value, preferredMode) => {
    const normalizedZoom = clampZoomPercent(value);
    const normalizedMode = normalizeZoomMode(preferredMode || zoomMode);
    setZoomPercent(normalizedZoom);
    setZoomMode(normalizedMode);

    if (user?.user_id) {
      setStoredZoomForUser(String(user.user_id), normalizedZoom, normalizedMode);
      clearLegacyZoomStorage();
    }

    window.dispatchEvent(
      new CustomEvent('app_zoom_update', {
        detail: {
          zoomPercent: normalizedZoom,
          zoomMode: normalizedMode
        }
      })
    );
    return normalizedZoom;
  }, [user?.user_id, zoomMode]);

  const saveZoomPreference = useCallback(async (zoomValue) => {
    const payload = {
      userId: user?.user_id,
      zoom: zoomValue
    };

    if (!payload.userId) return;
    try {
      await axios.post(`${REST_API_END_POINT}teams/update-user-zoom-preference`, payload);
    } catch (error) {
      console.log('Error saving user zoom preference', error);
    }
  }, [user?.user_id]);

  const updateZoomPreference = useCallback((nextZoom, nextMode) => {
    const normalizedZoom = applyZoomPreference(nextZoom, nextMode);
    saveZoomPreference(normalizedZoom);
  }, [applyZoomPreference, saveZoomPreference]);

  const handleZoomOut = useCallback(() => {
    updateZoomPreference(zoomPercent - APP_ZOOM_STEP);
  }, [zoomPercent, updateZoomPreference]);

  const handleZoomIn = useCallback(() => {
    updateZoomPreference(zoomPercent + APP_ZOOM_STEP);
  }, [zoomPercent, updateZoomPreference]);

  const updateZoomAnchorPosition = useCallback(() => {
    const el = zoomButtonRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setZoomAnchorPosition({
      top: rect.bottom,
      left: rect.left + rect.width / 2,
    });
  }, []);

  const handleZoomPopoverOpen = useCallback(() => {
    updateZoomAnchorPosition();
  }, [updateZoomAnchorPosition]);

  const handleZoomPopoverClose = useCallback(() => {
    setZoomAnchorPosition(null);
  }, []);

  const isChromium = useMemo(() => isChromiumBrowser(), [])
  const zoomLottieAnimation = useMemo(
    () => applyLottiePrimaryColor(ZoomLottieAnimation, hexToLottieColor(theme.palette.primary.main)),
    [theme.palette.primary.main]
  )
  const effectiveZoomMode = zoomMode === APP_ZOOM_MODE_VISUAL && isChromium
    ? APP_ZOOM_MODE_VISUAL
    : APP_ZOOM_MODE_COMPACT
  const isZoomPopoverOpen = Boolean(zoomAnchorPosition);
  useEffect(() => {
    if (!isZoomPopoverOpen) return undefined;

    const handleReposition = () => {
      requestAnimationFrame(() => {
        updateZoomAnchorPosition();
      });
    };
    window.addEventListener('resize', handleReposition);
    window.addEventListener('app_zoom_update', handleReposition);

    return () => {
      window.removeEventListener('resize', handleReposition);
      window.removeEventListener('app_zoom_update', handleReposition);
    };
  }, [isZoomPopoverOpen, updateZoomAnchorPosition]);

  const handleSearch = async (barcode) => {
    if (barcode && barcode.trim()) {
      try {
        // Search for the product by barcode to determine if it's a material
        const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
          barcode: barcode.trim(),
          userId: user?.user_id,
          userType: user?.user_type
        });

        let targetPath = PATH_DASHBOARD.products.main; // Default to products main
        
        if (response.data.status === 1 && response.data.results && response.data.results.length > 0) {
          // Check the meterial and isAdditionalProduct properties from the first result
          const firstProduct = response.data.results[0];
          // if (firstProduct.meterial === 1 && firstProduct.isAdditionalProduct === 0) {
          //   targetPath = PATH_DASHBOARD.inventoryAudit.root;
          // } else if (firstProduct.meterial === 1) {
          //   targetPath = PATH_DASHBOARD.products.material;
          // } else {
          //   targetPath = PATH_DASHBOARD.products.main;
          // }
          if (firstProduct.meterial === 1) {
            targetPath = PATH_DASHBOARD.products.material;
          } else {
            targetPath = PATH_DASHBOARD.products.main;
          }
        }
        
        navigate(targetPath, { 
          state: { barcode: barcode.trim() },
          replace: false
        });
      } catch (error) {
        console.error("Error searching product by barcode:", error);
        // On error, navigate to products main as fallback
        navigate(PATH_DASHBOARD.products.main, { 
          state: { barcode: barcode.trim() },
          replace: false
        });
      }
    }
  };

  const handleQRScan = (decodedText) => {
    setOpenQRScanner(false);
    handleSearch(decodedText);
  };

  const dialogBackdropProps = useMemo(() => ({
    sx: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
  }), [])

  useEffect(()=>{
    const fetchUserData = async ()=>{
      try {
        const response = await axios.post(`${REST_API_END_POINT}teams/get-user-active`);
        if (response.data.status === 1) {
          const data = response?.data?.data
          const active = data?.online === 1 ? true : false
          setIsActive(active)
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchUserData();
  },[])

  useEffect(() => {
    const initializeZoomPreference = async () => {
      if (!user?.user_id) return;

      // CHANGED: software zoom removed — always reset to 100% on load; users use browser zoom.
      applyZoomPreference(DEFAULT_APP_ZOOM_PERCENT, APP_ZOOM_MODE_VISUAL);
      clearLegacyZoomStorage();

      /*
      const userId = String(user.user_id);
      const storedPreference = getStoredZoomForUser(userId);

      // Original: zoom button hidden — always force DEFAULT_APP_ZOOM_PERCENT (90%) on load
      // try {
      //   const response = await axios.post(`${REST_API_END_POINT}teams/get-user-zoom-preference`, {
      //     userId: user.user_id
      //   });
      //   if (response?.data?.status === 1) {
      //     applyZoomPreference(response.data.zoom, storedPreference.zoomMode);
      //     clearLegacyZoomStorage();
      //     return;
      //   }
      // } catch (error) {
      //   console.log('Error fetching user zoom preference', error);
      // }
      // applyZoomPreference(storedPreference.zoomPercent, storedPreference.zoomMode);
      // applyZoomPreference(DEFAULT_APP_ZOOM_PERCENT, storedPreference.zoomMode);
      */
    };

    initializeZoomPreference();
  }, [applyZoomPreference, user?.user_id]);

  const handleZoomModeChange = useCallback((mode) => {
    updateZoomPreference(zoomPercent, normalizeZoomMode(mode))
  }, [updateZoomPreference, zoomPercent])

  useEffect(() => {
    const updateBannerFromStorage = () => {
      setMaintenanceBannerShow(localStorage.getItem('maintenance_banner_show') === 'true');
      setMaintenanceBannerText(localStorage.getItem('maintenance_banner_text') || '');
    };

    const fetchMaintenanceBanner = async () => {
      try {
        const response = await axios.post(`${REST_API_END_POINT}settings/get-maintenance-banner`)
        if (response.data.status === 1) {
          const isShow = response.data.show === 1 || response.data.show === true || response.data.show === '1';
          const text = response.data.text || '';
          localStorage.setItem('maintenance_banner_show', String(isShow));
          localStorage.setItem('maintenance_banner_text', text);
          setMaintenanceBannerShow(isShow);
          setMaintenanceBannerText(text);
        }
      } catch (err) {
        console.log('Error fetching maintenance banner', err)
      }
    }

    updateBannerFromStorage();
    fetchMaintenanceBanner();

    window.addEventListener('maintenance_banner_update', updateBannerFromStorage);
    return () => {
      window.removeEventListener('maintenance_banner_update', updateBannerFromStorage);
    };
  }, []);

  useEffect(() => {
    if (openQRScanner) {
      setTimeout(() => {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("navbar-qr-reader", { fps: 10, qrbox: 250 });

          scannerRef.current.render(
            (decodedText) => {
              handleQRScan(decodedText);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [openQRScanner]);

  console.log('$$$$$$$$$$$$$$$^^^^^^^^^^^^^^', user)
  return (
    <RootStyle
      sx={{
        [theme.breakpoints.up('lg')]: {
          width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
        },
      }}
    >
      <ToolbarStyle>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', mt: QBShow ? 2 : 0, }}>
          <MHidden width="lgUp">
            <IconButton
              onClick={onOpenSidebar}
              sx={{ mr: 1, color: 'text.primary' }}
            >
              <Icon icon={menu2Fill} />
            </IconButton>
          </MHidden>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
              width: '100%',
            }}
          >
            {user ? <FloatingChat /> : null}
            <BarcodeSearchField
              onSearch={handleSearch}
              onOpenQRScanner={() => setOpenQRScanner(true)}
            />
            {shouldShowSwitchWithPinInToolbar && (
              <Button
                size="small"
                color='success'
                sx={{ 
                  cursor: 'pointer', 
                  color: '#fff',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'light' ? 'rgba(15, 73, 0, 0.81)' : 'rgba(255, 255, 255, 0.1)',
                  },
                }}
                variant="contained"
                onClick={() => navigate(PATH_DASHBOARD.switchUserWithPin)}
                startIcon={<SwitchAccount />}
              >
                Switch User With PIN
              </Button>
            )}
            <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
              <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography>Scan QR Code</Typography>
                  <IconButton size="small" onClick={() => setOpenQRScanner(false)}>
                    <Close />
                  </IconButton>
                </Box>
              </DialogTitle>
              <DialogContent>
                <div id="navbar-qr-reader" style={{ width: "100%" }}></div>
              </DialogContent>
            </Dialog>
            {/* <Typography variant="h2" sx={{ml:25}}>{currentFacilityName}</Typography> */}
            {user && (admin || hasSwitched) && (
              <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'nowrap',
                  minWidth: 0, // important for ellipsis
                  flex: 1,     // allow it to grow/shrink
                }}
              >
                <Tooltip title={`Logged in as ${displayUserName}`}>
                  <Typography
                    variant="h5"
                    noWrap
                    sx={{
                      maxWidth: '320px', // or adjust as needed
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    Logged in as {displayUserName}
                  </Typography>
                </Tooltip>
                {/* {isSwitchedViaPin && originalUserId && (
                  <Button
                    variant="outlined"
                    type="submit"
                    startIcon={<ExitToApp />}
                    onClick={exitPinSwitch}
                    sx={{ mb: 0, mt: 0 }}
                  >
                    Exit
                  </Button>
                )} */}
                {shouldShowSwitchWithPinWhenSwitched && (
                  <Button
                    size="small"
                    color="success"
                    variant="contained"
                    startIcon={<SwitchAccount />}
                    onClick={() => navigate(PATH_DASHBOARD.switchUserWithPin)}
                    sx={{
                      mb: 0,
                      mt: 0,
                      color: '#fff',
                      boxShadow: 'none',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        backgroundColor: theme.palette.mode === 'light' ? 'rgba(15, 73, 0, 0.81)' : 'rgba(255, 255, 255, 0.1)',
                      },
                    }}
                  >
                    Switch User With PIN
                  </Button>
                )}
                {/* {shouldShowSwitchWithPinWhenSwitched && (
                  <Button
                    variant="outlined"
                    type="submit"
                    startIcon={<SwitchAccount />}
                    onClick={() => navigate(PATH_DASHBOARD.switchUserWithPin)}
                    sx={{ mb: 0, mt: 0 }}
                  >
                    Switch User With PIN
                  </Button>
                )} */}
                {/* {isSwitchedViaPin &&
                  originalUserId &&
                  user?.user_id?.toString() !== pinUserId && (
                  <Button
                    variant="outlined"
                    type="submit"
                    onClick={switchBackToOriginalUser}
                    sx={{ mb: 0, mt: 0 }}
                  >
                    Switch Back
                  </Button>
                )} */}
                {/* {!(isSwitchedViaPin || originalUserId) && !user?.isFromAdmin && !user?.isFromClient && (
                  <>
                    {addedByClient && !isFromAdmin ? (
                      ''
                    ) : (
                      <Button
                        variant="outlined"
                        type="submit"
                        onClick={loginAsUser}
                        sx={{ mb: 0, mt: 0 }}
                      >
                        Switch to {user_type == 8 ? 'Prod Manager' : 'Admin'}
                      </Button>
                    )}
                    {addedByClient ? (
                      <Button
                        variant="outlined"
                        type="submit"
                        onClick={loginAsClient}
                        sx={{ mb: 0, mt: 0 }}
                      >
                        Switch to Client
                      </Button>
                    ) : (
                      ''
                    )}
                  </>
                )} */}
                {!(isSwitchedViaPin || originalUserId) && (
                  <>
                    {addedByClient && !isFromAdmin ? (
                      ''
                    ) : (
                      <Button
                        variant="outlined"
                        type="submit"
                        // component={RouterLink}
                        // to={PATH_DASHBOARD.client.cards}
                        onClick={loginAsUser}
                        sx={{ mb: 0, mt: 0 }}
                      >
                        Switch to {user_type == 8 ? 'Prod Manager' : 'Admin'}
                      </Button>
                    )}
                    {addedByClient ? (
                      <Button
                        variant="outlined"
                        type="submit"
                        // component={RouterLink}
                        // to={PATH_DASHBOARD.client.cards}
                        onClick={loginAsClient}
                        sx={{ mb: 0, mt: 0 }}
                      >
                        Switch to Client
                      </Button>
                    ) : (
                      ''
                    )}
                  </>
                )}
                </Box>
              </>
            )}
          </Box>
          <Box sx={{ flexGrow: 1 }} />

          <Stack direction="row" spacing={{ xs: 0.5, sm: 1.5 }}>
              {user?.user_id === 667 ? (
                <Stack display={'flex'} flexDirection={'row'} alignItems={'center'} ml={1} gap={2}>
                  <Typography variant='body2' sx={{ whiteSpace: 'nowrap' }}>Support Agent</Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                      />
                    }
                    labelPlacement="end"
                    label={!isActive ? "Offline" : "Online"}
                    checked={isActive}
                    onChange={(e) => handleActiveToggle(e.target.checked)}
                    sx={{
                      mt: 0,
                      '& .MuiFormControlLabel-label': {
                        color: isActive ? 'green' : 'red',
                        fontWeight: 700,
                      },
                    }}
                  />
                </Stack>
              ) : null}
              {/* <LanguagePopover /> */}
              {/* HIDDEN: Display zoom removed — users adjust via browser zoom (Ctrl/Cmd +/-).
              <Tooltip title="Display zoom">
                <IconButton
                  ref={zoomButtonRef}
                  color="primary"
                  onClick={handleZoomPopoverOpen}
                  sx={{
                    width: 48,
                    height: 48,
                    overflow: 'visible',
                    borderRadius: 1.5,
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.32)}`,
                    backgroundColor: alpha(theme.palette.primary.main, 0.16),
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.primary.main, 0.18),
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'visible',
                      pointerEvents: 'none',
                      filter: 'drop-shadow(0 0 0.45px #fff)',
                    }}
                  >
                    <Lottie
                      animationData={zoomLottieAnimation}
                      loop
                      autoplay
                      style={{ width: 72, height: 72 }}
                    />
                  </Box>
                </IconButton>
              </Tooltip>
              */}
              {/* HIDDEN: Display zoom popover hidden from UI — code preserved, rendered never */}
              {false && <Popover
                open={isZoomPopoverOpen}
                onClose={handleZoomPopoverClose}
                anchorReference="anchorPosition"
                anchorPosition={zoomAnchorPosition}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                disableRestoreFocus
                PopperProps={{ strategy: 'fixed' }}
                PaperProps={{
                  sx: {
                    mt: 1.25,
                    p: 1.5,
                    minWidth: 190,
                    width: 'auto',
                    overflow: 'visible',
                    borderRadius: 2,
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
                    boxShadow: '0 14px 32px rgba(0,0,0,0.25)',
                    background: theme.palette.mode === 'dark'
                      ? `linear-gradient(145deg, ${alpha(theme.palette.background.paper, 0.96)} 0%, ${alpha(theme.palette.background.default, 0.94)} 100%)`
                      : `linear-gradient(145deg, ${alpha(theme.palette.common.white, 0.98)} 0%, ${alpha(theme.palette.primary.main, 0.05)} 100%)`,
                    backdropFilter: 'blur(8px)',
                  },
                }}
              >
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
                  Display Zoom
                </Typography>
                <Divider sx={{ mb: 1.25 }} />
                {/* Visual zoom only — compact mode not needed
                <Stack direction="row" spacing={1} sx={{ mb: 1.25 }}>
                  <Button
                    size="small"
                    variant={zoomMode === APP_ZOOM_MODE_VISUAL ? 'contained' : 'outlined'}
                    onClick={() => handleZoomModeChange(APP_ZOOM_MODE_VISUAL)}
                    disabled={!isChromium}
                  >
                    Visual
                  </Button>
                  <Button
                    size="small"
                    variant={zoomMode === APP_ZOOM_MODE_COMPACT ? 'contained' : 'outlined'}
                    onClick={() => handleZoomModeChange(APP_ZOOM_MODE_COMPACT)}
                  >
                    Compact
                  </Button>
                </Stack>
                */}
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                  <IconButton
                    onClick={handleZoomOut}
                    disabled={zoomPercent <= MIN_APP_ZOOM_PERCENT}
                    sx={{
                      borderRadius: 1.5,
                      border: `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
                    }}
                  >
                    <Remove fontSize="small" />
                  </IconButton>
                  <Typography
                    variant="h6"
                    sx={{
                      minWidth: 80,
                      textAlign: 'center',
                      fontWeight: 800,
                      color: 'primary.main',
                    }}
                  >
                    {zoomPercent}%
                  </Typography>
                  <IconButton
                    onClick={handleZoomIn}
                    disabled={zoomPercent >= MAX_APP_ZOOM_PERCENT}
                    sx={{
                      borderRadius: 1.5,
                      border: `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
                    }}
                  >
                    <Add fontSize="small" />
                  </IconButton>
                </Stack>
                <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.75 }}>
                  Range: {MIN_APP_ZOOM_PERCENT}% - {MAX_APP_ZOOM_PERCENT}%
                </Typography>
                {/* <Typography variant="caption" sx={{ display: 'block', mt: 0.5, opacity: 0.75 }}>
                  Active mode: Visual zoom
                </Typography> */}
                {!isChromium && (
                  <Typography variant="caption" sx={{ display: 'block', mt: 0.75, color: 'text.secondary' }}>
                    For exact browser zoom, use browser controls: Ctrl/Cmd +/-
                  </Typography>
                )}
              </Popover>}
              <NoteStickyIndividualPopup />
              <ChatbotTestBackup />
              <Tooltip
                title={themeMode === 'light' ? 'Switch to dark mode' : 'Day mode (light theme)'}
              >
              <IconButton
                color="inherit"
                onClick={() => {
                  const nextTheme = themeMode === 'light' ? 'dark' : 'light';
                  onChangeMode({ target: { value: nextTheme } });
                  handleThemeToggle(nextTheme);
                }}
                sx={{ width: 50, height: 50 }}
              >
                <Icon
                  style={{
                    fontSize: 50,
                    color: themeMode === 'light' ? '#ffd167' : '#ffd167', // Ensure the icon is black for light mode and white for dark mode
                  }}
                  icon={themeMode === 'light' ? moonFill : sunFill}
                  width={50}
                  height={50}
                />
              </IconButton>
              </Tooltip>
              {/* <AIChatbot/> */}
              <SettingFullscreen />
              <NotificationsPopover />

              {/* <ContactsPopover /> */}
              <AccountPopover />
            </Stack>
        </Box>

     {QBShow && !isQBBannerDismissed ?( <Box sx={{ width: '100%', mb: 2, position: 'relative' }}>
          <QBSyncBanner>
            <QBSyncTrack>
              <QBSyncRow>
                {Array.from({ length: QB_MARQUEE_REPEAT_COUNT }).map((_, idx) => (
                  <Box key={`qb-marquee-a-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                    <QBSyncText variant="subtitle2">{QB_MARQUEE_TEXT}</QBSyncText>
                    <QBSyncText variant="subtitle2" sx={{ opacity: 0.9 }}>•</QBSyncText>
                  </Box>
                ))}
              </QBSyncRow>
              <QBSyncRow aria-hidden="true">
                {Array.from({ length: QB_MARQUEE_REPEAT_COUNT }).map((_, idx) => (
                  <Box key={`qb-marquee-b-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                    <QBSyncText variant="subtitle2">{QB_MARQUEE_TEXT}</QBSyncText>
                    <QBSyncText variant="subtitle2" sx={{ opacity: 0.9 }}>•</QBSyncText>
                  </Box>
                ))}
              </QBSyncRow>
            </QBSyncTrack>
          </QBSyncBanner>
          <IconButton
            onClick={() => setIsQBBannerDismissed(true)}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'common.white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              backdropFilter: 'blur(4px)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              zIndex: 10,
              width: 32,
              height: 32,
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            }}
            size="small"
          >
            <Close sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>) : null}

     {maintenanceBannerShow && !isMaintenanceDismissed ? (
        <Box sx={{ width: '100%', mb: 2, position: 'relative' }}>
          <MaintenanceBanner>
            <QBSyncTrack>
              <QBSyncRow>
                {Array.from({ length: 6 }).map((_, idx) => (
                  <Box key={`m-marquee-a-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                    <CampaignOutlined sx={{ fontSize: 18, color: 'common.white' }} />
                    <MaintenanceText variant="subtitle2" sx={{ ml: 0.5 }}>{maintenanceBannerText}</MaintenanceText>
                    <MaintenanceText variant="subtitle2" sx={{ opacity: 0.9 }}>•</MaintenanceText>
                  </Box>
                ))}
              </QBSyncRow>
              <QBSyncRow aria-hidden="true">
                {Array.from({ length: 6 }).map((_, idx) => (
                  <Box key={`m-marquee-b-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                    <CampaignOutlined sx={{ fontSize: 18, color: 'common.white' }} />
                    <MaintenanceText variant="subtitle2" sx={{ ml: 0.5 }}>{maintenanceBannerText}</MaintenanceText>
                    <MaintenanceText variant="subtitle2" sx={{ opacity: 0.9 }}>•</MaintenanceText>
                  </Box>
                ))}
              </QBSyncRow>
            </QBSyncTrack>
          </MaintenanceBanner>
          <IconButton
            onClick={() => setIsMaintenanceDismissed(true)}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'common.white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              backdropFilter: 'blur(4px)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              zIndex: 10,
              width: 32,
              height: 32,
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            }}
            size="small"
          >
            <Close sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
     ) : null}
      </ToolbarStyle>
    </RootStyle>
  )
}
